var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:{
    'title-item-dark': _vm.$vuetify.theme.dark,
  }},[(_vm.$store.state.layout.loading)?_c('carregando'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }